__turbopack_context__.v({
  "coinActionBtn": "Header-module-scss-module__JsZkfa__coinActionBtn",
  "header": "Header-module-scss-module__JsZkfa__header",
  "hidden": "Header-module-scss-module__JsZkfa__hidden",
});
